import axios from 'axios';

// تهيئة الإعدادات الافتراضية للـ Axios
// Get the current hostname
const { protocol, hostname } = window.location;
export const BASE_URL = process.env.REACT_APP_API_URL || `${protocol}//${hostname}:8000`;
// API URL configuration
// Environment variable for API URL

const axiosInstance = axios.create({
    baseURL: BASE_URL,
    timeout: 10000,
    withCredentials: true,
    headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
    }
});

// إضافة معترض للطلبات لإضافة token التوثيق
axiosInstance.interceptors.request.use(
    async (config) => {
        try {
            // Get CSRF token only if we don't have it
            if (!document.cookie.includes('XSRF-TOKEN')) {
                await axios.get(`${BASE_URL}/sanctum/csrf-cookie`, { withCredentials: true });
            }

            // إذا كان الطلب يحتوي على FormData، نحذف Content-Type
            if (config.data instanceof FormData) {
                delete config.headers['Content-Type'];
            } else {
                config.headers['Content-Type'] = 'application/json';
            }

            // التحقق من وجود التوكن في sessionStorage
            const token = sessionStorage.getItem('token');
            if (token) {
                config.headers['Authorization'] = `Bearer ${token}`;
            }
            return config;
        } catch (error) {
            return Promise.reject(error);
        }
    },
    (error) => {
        return Promise.reject(error);
    }
);

// إضافة معترض للردود للتعامل مع الأخطاء
axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // الصفحات اللي مش محتاجة تسجيل دخول
        const publicPaths = [
            '/api/home',
            '/api/store',
            '/api/courses',
            '/api/settings',
            '/api/categories',
            '/sanctum/csrf-cookie'
        ];

        // الصفحات اللي مش بنحول منها لتسجيل الدخول
        const ignoredPaths = [
            '/login',
            '/admin/login',
            '/sanctum/csrf-cookie',
            '/api/settings/maintenance'
        ];

        // تحسين التحقق من المسارات الفرعية
        const isPublicPath = (url) => {
            // نفصل المسار إلى أجزاء
            const urlParts = url.split('?')[0].split('/');
            
            // حالة خاصة: مسار تفاصيل دورة معينة يجب أن يكون public
            // مثال: /api/courses/4 أو /api/courses/7
            if (urlParts.length >= 4 && 
                urlParts[1] === 'api' && 
                urlParts[2] === 'courses' && 
                !isNaN(parseInt(urlParts[3]))) {
                return true;
            }
            
            // نبحث في المسارات العامة
            for (const path of publicPaths) {
                // نفصل المسار العام إلى أجزاء
                const pathParts = path.split('/');
                
                // نتأكد أن كل أجزاء المسار العام موجودة في المسار المطلوب بنفس الترتيب
                let match = true;
                for (let i = 0; i < pathParts.length; i++) {
                    if (pathParts[i] !== urlParts[i]) {
                        match = false;
                        break;
                    }
                }
                
                if (match) return true;
            }
            
            return false;
        };
        
        // تحقق من المسارات المستثناة
        const isIgnoredPath = (url) => ignoredPaths.some(path => url.includes(path));

        // Request error information
        // Error details: status, URL, path type, and response data


        if (error.response?.status === 401 && 
            !isPublicPath(error.config.url) &&
            !isIgnoredPath(error.config.url)) {
            
            if (!window.loggingOut) {
                window.loggingOut = true;
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('user');
                sessionStorage.removeItem('userType');
                window.location.href = '/login';
            }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
